const state = {
  clicked: 0
}

const mutations = {
  click (state, a) {
    state.clicked = a
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
